export const sectionUrlToLink = (location, sectionUrl) => {
  return sectionUrl.replace(location.baseUrl, '').split('?', 2)[0];
};
